const DEFAULT_PUBLIC_ORIGIN = "https://www.zinnes.com.br";

const currentOrigin = () => (
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : DEFAULT_PUBLIC_ORIGIN
);

export function sanitizeHttpUrl(value, baseUrl = currentOrigin()) {
  if (typeof value !== "string" || !value.trim()) return null;

  try {
    const url = new URL(value.trim(), baseUrl);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    if (url.username || url.password) return null;
    return url.href;
  } catch {
    return null;
  }
}

export function openSafeHttpUrl(value, opener, baseUrl = currentOrigin()) {
  const safeUrl = sanitizeHttpUrl(value, baseUrl);
  if (!safeUrl) return false;

  const openWindow = opener || (typeof window !== "undefined" ? window.open.bind(window) : null);
  if (!openWindow) return false;

  const openedWindow = openWindow(safeUrl, '_blank', 'noopener,noreferrer');
  if (openedWindow) openedWindow.opener = null;
  return true;
}
